<template>
  <div
    class="flex-fJend-fAend chantierChoix"
    :style="{ display: display }"
  >
    <p class="flex-fJend-fAend js_panierLigne_selectChantier panierLigne_selectChantier">
      <label class="selectIcon selectChantier icon-notepad_validated">
        <select
          :id="'codeChantier' + idPanier"
          v-model="selectedOption"
          name="codeChantier"
          @change="setTag"
        >
          <option value="">
            {{ labelChooseTag }}
          </option>
          <option
            v-for="(tagOption, tagKey) in tagList"
            :value="tagOption"
            :key="tagKey"
          >
            {{ tagOption }}
          </option>
        </select><span class="flex-fJcenter-fAcenter icon-arrowdown" />
      </label>
    </p>
    <p
      class="flex-fJbetween-fAend js_panierLigne_addChantier panierLigne_addChantier"
      @click="addTag"
    >
      <span
        class="buttonIcon icon-more"
        :title="labelCreateTag"
      />
      <span v-html="labelCreateTag" />
    </p>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    display: {
      type: String,
      default: ''
    },
    idPanier: {
      type: String,
      default: ''
    },
    cartRowId: {
      type: String,
      default: ''
    },
    tagList: {
      type: Array,
      default() {
        return []
      }
    },
    selectedTag: {
      type: String,
      default: ''
    },
    labelCreateTag: {
      type: String,
      default: ''
    },
    labelChooseTag: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      selectedOption: ''
    }
  },
  updated: function() {
    if (this.selectedTag) {
      this.selectedOption = this.selectedTag
      this.$emit('tag-selected')
    }
  },
  created: function() {
    this.updateSelectedOption()
  },
  methods: {
    create: function(cartRowId, tagName) {
      let tagChantier = {
        id: cartRowId,
        tagName: tagName
      }
      return new Promise((resolve, reject) => {
        axios.post('/tag/chantier/', tagChantier).then(
          response => {
            resolve(response.data)
          },
          response => {
            reject(response)
          }
        )
      })
    },
    getTagName(cartRowId) {
      return new Promise((resolve, reject) => {
        axios.get('/tag/chantier/' + cartRowId).then(
          response => {
            resolve(response.data)
          },
          response => {
            reject(response)
          }
        )
      })
    },
    addTag: function() {
      this.$emit('add-tag')
    },
    setTag: function() {
      this.$emit('select-tag', [this.cartRowId, this.selectedOption, false])
    },
    updateSelectedOption: function() {
      this.getTagName(this.cartRowId).then(
        response => {
          this.selectedOption = response
        },
        response => console.log('Error - getTagName' + JSON.stringify(response))
      )
    }
  }
}
</script>

<style scoped>
  .chantierChoix label.selectIcon {
    height: 3rem;
    min-width: 20rem;
    margin: 0.1rem;
    flex-direction: row;
  }

  .buttonIcon[class*=icon-] {
    height: 3.2rem;
    min-width: 3.2rem;
    width: 3.2rem;
    margin: 0 0.2rem;
    padding: 0;
  }
  @media screen and (min-width: 940px) {
    .selectIcon {
      min-width: 18rem;
    }

    .selectIcon::before {
      height: 3rem;
      width: 3rem;
    }

    .selectIcon span.icon-arrowdown {
      margin-left: -2rem;
    }

    .buttonIcon[class*=icon-]::before {
      position: inherit;
      top: unset;
      left: unset;
    }
  }

  @media screen and (max-width: 939px) {
    .buttonIcon[class*=icon-]::before {
      margin-right: 0;
    }
  }

</style>
